import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Light from './headers/light';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Swal from 'sweetalert2';
import LightAdmin from './headers/lightAdmin';
import tw from "twin.macro";
import styled from "styled-components";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import ScrollToTop from './ScrollToTop';
import './ProductDetails.css';
import { useTranslation } from 'react-i18next';
const SectionTitle = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #336734;
  position: relative;
  width: 100%;

  &::before,
  &::after {
    content: "";
    width: 90px;
    border-bottom: 2px solid #d3d3d3;
    margin: 0 1rem;
  }
`;
const ProductDetails = () => {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const navigate = useNavigate();
    const [role, setRole] = useState('');
    const [isActive, setIsActive] = useState(true); // State to control button activity
    useEffect(() => {
        const userRole = localStorage.getItem('role');
        setRole(userRole);

        // Check if there is an admin role to decide button state
        const supplierRole = localStorage.getItem('role'); // Example check for admin presence
        if (supplierRole !== "supplier") {
            setIsActive(false); // Disable buttons if no admin
        }

        const fetchProductDetails = async () => {
            try {
                const response = await fetch(`https://elanciabioapi.com/api/products/${id}?lang=${i18n.language}`);
                if (!response.ok) throw new Error("Product not found");
                const data = await response.json();
                setProduct(data);
            } catch (error) {
                console.error("Error fetching product details:", error);
            }
        };
        fetchProductDetails();
    },[id, i18n.language] );
 // ✅ Correct
    useEffect(() => {
        const fetchRelatedProducts = async () => {
            try {
                const response = await fetch(`https://elanciabioapi.com/api/same-category-products/${id}?lang=${i18n.language}`);
                if (!response.ok) throw new Error("Related products not found");
                const data = await response.json();
                setRelatedProducts(data.products);
            } catch (error) {
                console.error("Error fetching related products:", error);
            }
        };
        fetchRelatedProducts();
    },[id, i18n.language] );
// ✅ Correct

   const handleAddToCart = () => {
        if (product.StockQuantity <= 0) {
            Swal.fire({
                title: t('Stock_epuise'),
                text: `${product.Name} ${t('Produit_rupture')}`,
                icon: 'error',
                confirmButtonText: t('ok')
            });
            return;
        }

        if (quantity > product.StockQuantity) {
            Swal.fire({
                title: t('Quantite_insuffisante'),
                text: `${t('Produit_rupture')}.`,
                icon: 'warning',
                confirmButtonText: t('ok')
            });
            return;
        }

        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        const existingProduct = cart.find(item => item.productID === product.ProductID);

        if (existingProduct) {
            existingProduct.quantity += quantity;
        } else {
            cart.push({
                productID: product.ProductID,
productName: parseLangField(product.Name),
                productImage: product.image,
                productPrice: role === 'supplier' ? product.distributeur_price : product.user_price,
                quantity: quantity
            })
        }
        localStorage.setItem('cart', JSON.stringify(cart));

Swal.fire({
  toast: true,
  position: 'top-end',
  icon: 'success',
  title: `${t('Produit_ajoute')} ${product.Name}`,
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
});
;
    };

    if (!product) return <div className="loading">{t('loading')}...</div>;
    const CardButton = tw(PrimaryButtonBase)`text-sm flex justify-center items-center mt-4 bg-[#336734] text-white border-none hover:bg-[#285427]`;
    const CardButtonContainer = tw.div`flex justify-center items-center mt-2 w-auto`;
const parseLangField = (field) => {
  try {
    const parsed = typeof field === "string" ? JSON.parse(field) : field;
    return parsed[i18n.language] || parsed.fr || "";
  } catch (e) {
    return field;
  }
};

    return (
        <AnimationRevealPage>
            <ScrollToTop />

{role === 'supplier' ? <Light /> : role === 'admin' ? <LightAdmin /> : <Light />}
            <div className="container mt-5">
            {role === "buyer" && (
  <div className="alert alert-danger">
    <p>Vous ne pouvez pas passer des commandes en tant que acheteur.</p>
  </div>
)}


                <div className="row align-items-center mb-5">
                    {/* Product Image */}
                    <div className="col-md-6 mb-4 d-flex justify-content-center">
          <div style={{
            width: '520px',
            height: '520px',
            background: '#f7f7f7',
            borderRadius: '16px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 16px 0 rgba(0,0,0,0.06)'
          }}>
            <img
              src={`https://elanciabioapi.com/storage/${product.image}`}
alt={parseLangField(product.Name)}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                transition: 'transform 0.3s',
              }}
            />
          </div>
        </div>
                    {/* Product Details */}
                    <div className="col-md-6" style={{marginTop:'0'}}>
                        <h2 style={{ color: '#336734', fontWeight: 'bold', fontSize: '2rem', marginBottom: '1rem' }}>
{parseLangField(product.Name)}
          </h2>
          <div className="mb-3">
            <span style={{ color: '#336734', fontSize: '1.5rem', fontWeight: 'bold' }}>
              {role === 'supplier' ? `${product.distributeur_price} DH` : `${product.user_price} DH`}
            </span>
          </div>
       <div
  className="text-muted mb-4 short-description line-clamp-3"
  dangerouslySetInnerHTML={{
    __html: parseLangField(product.Description)
  }}
></div>
          {product.StockQuantity === 0 && (
            <p className="mb-4" style={{ color: 'red', fontWeight: 'bold' }}>{t('out_of_stock')}</p>
          )}
          {/* Quantity Selector */}
          <div className="mb-4 d-flex align-items-center">
            <label htmlFor="quantity" className="form-label me-2" style={{fontWeight: 500}}>{t('quantity')}:</label>
            <button
              type="button"
              className="btn"
              style={{
                backgroundColor: '#336734',
                color: 'white',
                padding: '0.25rem 0.75rem',
                fontSize: '1.1rem',
                borderRadius: '6px'
              }}
              onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
            >-</button>
            <input
              type="number"
              className="form-control mx-2 text-center"
              id="quantity"
              value={quantity}
              min="1"
              max={product.StockQuantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              style={{
                width: '60px',
                border: '1px solid #336734',
                borderRadius: '6px'
              }}
            />
            <button
              type="button"
              className="btn"
              style={{
                backgroundColor: '#336734',
                color: 'white',
                padding: '0.25rem 0.75rem',
                fontSize: '1.1rem',
                borderRadius: '6px'
              }}
              onClick={() => setQuantity(prev => Math.min(product.StockQuantity, prev + 1))}
            >+</button>
          </div>
          {/* Action Buttons */}
          <div className="d-flex gap-3">
            <button
              className="btn"
              style={{
                backgroundColor: '#336734',
                color: 'white',
                width: '200px',
                fontSize: '16px',
                padding: '10px',
                borderRadius: '6px',
                fontWeight: 500,
                border: 'none'
              }}
              onClick={handleAddToCart}
            >
              <i className="bi bi-cart-plus"></i>{t('add_to_cart')}
            </button>
            <button
              className="btn"
              style={{
                backgroundColor: 'white',
                color: '#336734',
                border: '2px solid #336734',
                width: '200px',
                fontSize: '16px',
                padding: '10px',
                borderRadius: '6px',
                fontWeight: 500
              }}
              onClick={() => navigate('/checkout')}
            >
              <i className="bi bi-credit-card"></i> {t('Passer_a_la_caisse')}
            </button>
          </div>
        </div>
                </div>
{/* Long Description Section */}
<div
  className="p-4"
  style={{
    marginTop: '-2rem',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    background: '#f7f7f7',
    borderRadius: '12px'
  }}
>
      <SectionTitle>{t('Description')}</SectionTitle>
  <div
  className="text-muted mb-4"
  style={{
    whiteSpace: "normal",
    wordWrap: "break-word"
  }}
dangerouslySetInnerHTML={{
  __html: parseLangField(product.Description)
}}

></div>
</div>
      <SectionTitle>  {t('Produits_similaires')}</SectionTitle>
<br />
<div className="row">
  {relatedProducts.length > 0 ? (
    relatedProducts.slice(0, 4).map((relatedProduct) => (
      <div key={relatedProduct.ProductID} className="col-md-3 mb-4">
        <div
          className="card border-0"
          style={{
            boxShadow: "0 2px 16px 0 rgba(0,0,0,0.06)",
            borderRadius: "12px",
            background: "#fff"
          }}
        >
          <Link to={`/product-details/${relatedProduct.ProductID}`}>
            <img
              src={`https://elanciabioapi.com/storage/${relatedProduct.image}`}
              className="card-img-top"
              alt={relatedProduct.Name}
              style={{
                width: "100%",
                height: "180px",
                objectFit: "cover",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px"
              }}
            />
          </Link>
          <div className="card-body text-center">
                  <h5
                    className="card-title text-truncate"
                    style={{
                      fontSize: "1rem",
                      color: "#336734",
                      marginBottom: "0.5rem",
                      fontWeight: 600
                    }}
                  >
{parseLangField(relatedProduct.Name)}
                  </h5>
                  <p
                    className="card-text"
                    style={{
                      fontSize: "1.1rem",
                      color: "#707070",
                      marginBottom: "0.5rem"
                    }}
                  >
                    {role === "supplier"
                      ? `${relatedProduct.distributeur_price} DH`
                      : `${relatedProduct.user_price} DH`}
                  </p>
                  <CardButtonContainer>
                    <Link to={`/product-details/${relatedProduct.ProductID}`}>
                      <CardButton>{t('buy_now')}</CardButton>
                    </Link>
                  </CardButtonContainer>
                </div>
        </div>
      </div>
    ))
  ) : (
    <p>{t('Aucun_produit_similaire_trouve')}.</p>
  )}
</div>


            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default ProductDetails;
